import React from 'react';
import style from './SecondaryButton.module.css';
import spinner from '../../assets/Spinner.svg';

const SecondaryButton = ({ text, click, disabled, loading, width, type = 'button' }) => {
	const buttonStyle = width ? { width } : undefined;

	return (
		<button
			className={style.SecondaryButton}
			onClick={click}
			disabled={disabled || loading}
			style={buttonStyle}
			type={type}
		>
			{loading ? (
				<img src={spinner} alt="Loading" className={style.spinner} />
			) : (
				<span>{text}</span>
			)}
		</button>
	);
};

export default SecondaryButton;
